import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import axios from 'axios'
import 'element-ui/lib/theme-chalk/index.css'
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)

Vue.use(VueLazyload, {
    preLoad: 1.1
        // loading: 'dist/loading.gif'
})
Vue.use(ElementUI)
axios.defaults.withCredentials = true
axios.defaults.baseURL = 'http://hgserver.lusenky.com'
    // axios.defaults.baseURL='http://lsserver.lusenky.com:8080'
    // axios.defaults.baseURL='http://192.168.3.129:8083/' 

// var _hmt = _hmt || [];
// (function() {
//   var hm = document.createElement("script");
//   hm.src = "https://hm.baidu.com/hm.js?f11e98084958982e02d0e3752bd57dfd";
//   var s = document.getElementsByTagName("script")[0]; 
//   s.parentNode.insertBefore(hm, s);
// })();

// var _hmt = _hmt || [];
// (function() {
//   var hm = document.createElement("script");
//   hm.src = "https://hm.baidu.com/hm.js?d2c29b5689a9b37eb7450f38ab04495e";
//   var s = document.getElementsByTagName("script")[0];
//   s.parentNode.insertBefore(hm, s);
// })();

Vue.prototype.axios = axios
Vue.config.productionTip = false

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')